<template>
    <b-modal
        :id="'update-skill-tree-' + skillTreeIn.id"
        :title="$t('skill_tree.edit_set')"
        :ok-title="$t('common.save')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        @ok="onOk()"
        @show="onShow"
        modal-class="apprentice-default-modal">
        <div class="edit-skill-tree">
            <b-form-group
                :label="$t('common.name')"
                label-for="skill-name-input">
                <template v-slot:label> {{ $t('common.name') }} <span class="required">*</span></template>
                <b-form-input
                    id="skill-name-input"
                    v-model="name"
                    required
                    :placeholder="$t('common.name')">
                </b-form-input>
            </b-form-group>

            <b-form-group
                v-if="lasGroupsIn.length"
                :label="$t('skill_tree.lesson_groups')"
                label-for="skill-las-group-select">
                <template v-slot:label>
                    {{ $t('skill_tree.lesson_groups') }}
                </template>

                <design-2021-apprentice-multiselect-component
                    id="skill-las-group-select"
                    @input="updateLasGroups($event)"
                    :selected-in="selectedLasGroups"
                    value-field="id"
                    label="name"
                    :options="lasGroupsIn"
                    :multiple-select="true"></design-2021-apprentice-multiselect-component>
            </b-form-group>

            <b-form-group
                v-if="lasMainGroupsIn.length"
                :label="$t('skill_tree.main_groups')"
                label-for="skill-las-main-group-select">
                <template v-slot:label>
                    {{ $t('skill_tree.main_groups') }}
                </template>

                <design-2021-apprentice-multiselect-component
                    id="skill-level-select"
                    @input="updateLasMainGroups($event)"
                    :selected-in="selectedLasMainGroups"
                    value-field="id"
                    label="name"
                    :options="lasMainGroupsIn"
                    :multiple-select="true"></design-2021-apprentice-multiselect-component>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
import { ords } from '../../../app';

export default {
    name: 'design-2021-skilltree-update-modal-component',
    props: ['lasGroupsIn', 'lasMainGroupsIn', 'skillTreeIn'],
    data() {
        return {
            name: this.skillTreeIn.name,
            selectedLasGroups: [],
            selectedLasMainGroups: [],
        };
    },
    methods: {
        updateLasMainGroups(event) {
            this.selectedLasMainGroups = event;
        },

        updateLasGroups(event) {
            this.selectedLasGroups = event;
        },

        updateResponseLasGroups(response) {
            let lasGroupOldIds = this.skillTreeIn.las_groups.map((item) => {
                return item.id;
            });

            let newLasGroupIds = response.data.las_groups.map((item) => {
                return item.id;
            });

            let toBeDeleted = lasGroupOldIds.filter((x) => !newLasGroupIds.includes(x));
            let toBeInserted = newLasGroupIds.filter((x) => !lasGroupOldIds.includes(x));

            this.skillTreeIn.detach('las_groups', toBeDeleted);

            for (const group of response.data.las_groups) {
                if (toBeInserted.includes(group.id)) {
                    this.skillTreeIn.addRelation('las_groups', group);
                }
            }

            this.selectedLasGroups = response.data.las_groups;
        },

        updateResponseLasMainGroups(response) {
            let lasMainGroupOldIds = this.skillTreeIn.las_main_groups.map((item) => {
                return item.id;
            });

            let newLasMainGroupIds = response.data.las_main_groups.map((item) => {
                return item.id;
            });

            let toBeDeleted = lasMainGroupOldIds.filter((x) => !newLasMainGroupIds.includes(x));
            let toBeInserted = newLasMainGroupIds.filter((x) => !lasMainGroupOldIds.includes(x));

            this.skillTreeIn.detach('las_main_groups', toBeDeleted);

            for (const group of response.data.las_main_groups) {
                if (toBeInserted.includes(group.id)) {
                    this.skillTreeIn.addRelation('las_main_groups', group);
                }
            }

            this.selectedLasMainGroups = response.data.las_main_groups;
        },

        onOk() {
            let data = {
                name: this.name,
                lasGroups: this.selectedLasGroups.map((item) => {
                    return { id: item.id };
                }),
                lasMainGroups: this.selectedLasMainGroups.map((item) => {
                    return { id: item.id };
                }),
            };

            this.alert.saving();

            this.axios.post(this.routes.skillTreeUpdate(this.skillTreeIn.id), data).then(
                (response) => {
                    ords.hold();

                    this.skillTreeIn.update({ name: response.data.name });

                    this.updateResponseLasGroups(response);
                    this.updateResponseLasMainGroups(response);

                    ords.continue();

                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        onShow() {
            this.name = this.skillTreeIn.name;
            this.selectedLasMainGroups = this.skillTreeIn.las_main_groups;
            this.selectedLasGroups = this.skillTreeIn.las_groups;
        },
    },
};
</script>

<style scoped lang="scss">
.selected-skill-tree-previews {
    .selected-skill {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        flex: 1;
        margin-left: -#{map-get($grid-gutter-spacing, 'twenty-one')};
        margin-right: -#{map-get($grid-gutter-spacing, 'twenty-one')};
        padding: map-get($grid-gutter-spacing, 'fifteen') map-get($grid-gutter-spacing, 'twenty-one');

        .title {
            display: inline-flex;
            flex-grow: 1;
            font-size: 1.3125rem;
            font-weight: $font-weight-bold;
            color: $primary;

            .icon {
                margin-right: map-get($grid-gutter-spacing, 'eight');
            }
        }

        .school-years {
            .school-year {
                padding: map-get($grid-gutter-spacing, 'eight') map-get($grid-gutter-spacing, 'twenty-one');
                border-bottom: 3px dotted $border-color;

                label {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 0;
                }
            }
        }

        .btn-remove-skill {
            font-size: $default-font-size;
            margin-top: map-get($grid-gutter-spacing, 'twenty-one');
            display: flex;
            align-items: center;
            flex-direction: row;
            align-self: flex-end;

            i {
                margin-right: map-get($grid-gutter-spacing, 'eight');
            }
        }

        &:nth-child(even) {
            background-color: $secondary-background-color;
        }
    }
}
</style>
